import React from 'react';
import '../../styles/sections.css';
import '../../styles/requirements.css';

const Requirements = () => {
  return (
          <section className="requirements-section" style={{ marginTop: '6rem' }}>
        <div className="section-header">
          <h2>REQUIREMENTS</h2>
          <div className="underline"></div>
        </div>
        <div className="requirements-content">
        <ul>
          <li>
            <strong>Hardware Requirements:</strong> A minimum of Windows 10 is required on the local machine accessing Notify. Since the site is hosted on Azure, only basic client-side hardware is needed to interact with the web platform.
          </li>
          <li>
            <strong>Software Requirements:</strong> ASP.NET 7.0 with C# was used for the backend, and MySQL 8.0 for the database. These frameworks form the core web stack for Notify's functionality.
          </li>
          <li>
            <strong>Documentation & Comments:</strong> All models and methods are commented thoroughly to ensure maintainability. Properties are described with their purpose, and methods are annotated to walk developers through each logical step.
          </li>
          <li>
            <strong>Error Checking & Handling:</strong> Try-catch blocks are used to catch exceptions. User input is validated before interacting with the database. Unexpected errors are handled gracefully with a redirect to a generic error page that avoids exposing sensitive backend details.
          </li>
          <li>
            <strong>Software Versioning:</strong> GitHub is used for version control. Major Sprint cycles determine version numbers (e.g., V1.0, V2.0), while minor updates determine patch numbers (e.g., V1.1, V2.2).
          </li>
          <li>
            <strong>Data Requirements:</strong> All application data is stored in a MySQL database, accessed through structured queries and secured connection logic.
          </li>
          <li>
            <strong>File Structure:</strong> The codebase follows N-tier architecture, organized into Models, Business Logic, Views, and Services to enforce separation of concerns.
          </li>
          <li>
            <strong>Schema Objects:</strong> ERD and schema diagrams were designed and referenced to define and visualize database objects and their relationships.
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Requirements;
